import { useEffect, useState, useRef } from "react";
import CheckBox from "./CheckBox";
import "../css/Dropdown.css";
import "../css/DropdownFilter.css";
import Tag from "./Tag";

export default function DropdownFilter(props) {
  const [togglePanel, setTogglePanel] = useState(false);
  const [selectedOp, setSelectedOp] = useState(
    props.optionList.length > 0 ? props.optionList[0] : { id: "", text: "" },
  );
  const [optionList, setOptionList] = useState([]);
  const [selectedOptionList, setSelectedOptionList] = useState([]);
  const dropdownRef = useRef(null);

  const getComboboxSize = () => {
    let additionalClass = "";
    switch (props.size) {
      case 0:
        additionalClass = "combobox-full";
        break;
      case 1:
        additionalClass = "combobox-small";
        break;
      case 2:
        additionalClass = "combobox-medium";
        break;
      case 3:
        additionalClass = "combobox-large";
        break;
      case 4:
        additionalClass = "combobox-small-2";
        break;
      default:
        additionalClass = "combobox-default";
        break;
    }
    return additionalClass;
  };

  useEffect(() => {
    const refineOptionList = () => {
      const list =
        props.optionList.length > 0
          ? props.optionList.map((e, i) => {
              return (
                <div
                  className={`dropdown-op ${
                    e.id === selectedOp.id ? "selected-op" : ""
                  }`}
                  key={i}
                  onClick={() => {
                    if (selectedOp.text !== e.text) {
                      props.onChange(e);
                      setSelectedOp(e);
                      setSelectedOptionList((prev) => {
                        if (props.selectedOptions.includes(e.id))
                          return [...prev];
                        else return [...prev, e];
                      });
                      setTogglePanel(false);
                    }
                  }}
                >
                  <CheckBox active={e.active} onClick={() => {}}></CheckBox>
                  <span>{e.text}</span>
                </div>
              );
            })
          : [
              <div className="dropdown-op" key={0}>
                <span>No options</span>
              </div>,
            ];
      setOptionList(list);
      const found = props.optionList.find((e) => {
        return e.id === props.op;
      });
      setSelectedOp(found ? found : { id: props.op, text: props.op });
    };
    refineOptionList();
  }, [props, selectedOp.id]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setTogglePanel(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div
      className={`combobox ${getComboboxSize()} combobox-filter`}
      ref={dropdownRef}
    >
      <div
        className={`dropdown ${togglePanel ? "dropdown-open" : ""} ${
          props.disabled ? "dropdown-disabled" : ""
        }`}
        onClick={() => {
          if (!props.disabled) {
            setTogglePanel(!togglePanel);
          }
        }}
      >
        {props.icon && <img src={props.icon} alt="icon"></img>}
        <div className="languagetext">
          <div className="text">{selectedOp.text}</div>
        </div>
        <div className="downicon">
          <img
            src="/images/blue-down-arrow.svg"
            loading="lazy"
            alt="Panel icon"
            className="vectors-wrapper-11"
          />
        </div>
      </div>
      {togglePanel && <div className="dropdown-options">{optionList}</div>}
      {props.selectedOptions && props.selectedOptions.length > 0 && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            paddingTop: "5px",
            gap: 5,
          }}
        >
          {props.optionList.map((e, i) => {
            if (props.selectedOptions && props.selectedOptions.includes(e.id)) {
              return (
                <Tag
                  mini={true}
                  text={e.text}
                  key={i}
                  tagId={i}
                  onClick={() => {
                    props.onChange(e);
                  }}
                ></Tag>
              );
            }
          })}
        </div>
      )}
    </div>
  );
}
